import styled from "@emotion/styled";
import {
  zIndex,
  spacing,
  duration,
  letterSpacing,
  lineHeight,
  nav,
  text,
  expandWithFadeIn,
} from "@atlas-int/tokens";

export const HeaderAtlasLogo = styled.div`
  display: block;
  margin-left: auto;

  & img {
    height: ${spacing[20]};
    min-height: ${spacing[20]};
  }
`;

export const HeaderNavigationList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  color: ${text.primary};
  padding: 0;
`;

export const HeaderNavigationListItem = styled.li`
  height: 100%;
  display: flex;
  align-items: center;
  cursor: default;
  position: relative;
  background-color: transparent;
  color: inherit;

  & a,
  & button {
    height: 100%;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    padding-right: ${spacing[4]};
    padding-left: ${spacing[4]};
    text-transform: uppercase;
    letter-spacing: ${letterSpacing.caps};
    font-size: clamp(8px, 2vw, 0.9375rem);
    text-decoration: none;
    color: inherit;
  }

  /* Top-level links are clickable; the Learn trigger only opens a submenu */
  & > a {
    cursor: pointer;
  }

  /* Reset native button chrome so the Learn trigger matches the link items */
  & button {
    background: none;
    border: none;
    font-family: inherit;
  }

  &:hover,
  &.highlight {
    background-color: ${nav.surface};
    color: ${text.onDark};
  }
`;

export enum Side {
  Left = "left",
  Right = "right",
}

export const InnerUl = styled.ul<{ side: Side }>`
  position: absolute;
  top: 100%;
  z-index: ${zIndex.dropdown};
  right: ${({ side }) => (side === Side.Left ? "" : 0)};
  left: ${({ side }) => (side === Side.Left ? 0 : "")};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${spacing[8]};
  background-color: ${nav.surface};
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  animation-name: ${expandWithFadeIn};
  animation-duration: ${duration.fast};
  animation-timing-function: linear;
  animation-delay: ${duration.slow};
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  list-style-type: none;
`;

export const InnerLi = styled.li`
  white-space: nowrap;
  line-height: ${lineHeight.loose};
  text-align: left;
  color: ${text.onDark};


  && a {
    text-transform: none;
    letter-spacing: ${letterSpacing.none};
  }

  & :hover {
    text-decoration: underline;
  }
`;

export const InnerLiAnchor = styled.a`
  display: block;

  span {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: transparent;
  }

  &:hover span {
    border-bottom-color: ${text.onDark};
  }
`;
